export default function Footer() {
  const navLinks = ['home', 'about', 'services', 'projects', 'team', 'contact'];
  const services = ['Mechanical Engineering', 'Civil Engineering', 'Project Management', 'Mining Services'];

  return (
    <footer>
      <div className="ft">
        <div className="fb">
          <div className="fn">FM MAEPA (PTY) LTD</div>
          <div className="fs">Engineering</div>
          <p>A proudly South African, multidisciplinary engineering company serving mining, civil, and industrial sectors since 2015.</p>
          <p style={{ marginTop: 8 }}>www.fmmaepa.co.za</p>
        </div>
        <div className="fc">
          <h4>Navigation</h4>
          <ul>
            {navLinks.map(l => (
              <li key={l}><a href={`#${l}`}>{l === 'home' ? 'Home' : l === 'about' ? 'About Us' : l === 'team' ? 'Our Team' : l.charAt(0).toUpperCase() + l.slice(1)}</a></li>
            ))}
          </ul>
        </div>
        <div className="fc">
          <h4>Services</h4>
          <ul>
            {services.map(s => <li key={s}><a href="#services">{s}</a></li>)}
          </ul>
        </div>
        <div className="fc">
          <h4>Contact</h4>
          <ul>
            <li><a href="#">Highveld, Witbank, Mpumalanga</a></li>
            <li><a href="tel:0827988620">082 798 8620</a></li>
            <li><a href="tel:0136500404">013 650 0404</a></li>
            <li><a href="mailto:forster@fmmaepa.co.za">forster@fmmaepa.co.za</a></li>
            <li><a href="https://www.fmmaepa.co.za" target="_blank" rel="noreferrer">www.fmmaepa.co.za</a></li>
          </ul>
        </div>
      </div>
      <div className="fbot">
        <p>© {new Date().getFullYear()} FM Maepa (Pty) Ltd Engineering. All rights reserved.</p>
        <div className="badges">
          <span className="bp">Est. 2015</span>
          <span className="bp">South African</span>
          <span className="bp">Multidisciplinary</span>
        </div>
      </div>
    </footer>
  );
}
